import { SET_OFFSET } from '../constants';

export const setOffset = offset => dispatch => {
	dispatch({ type: SET_OFFSET, payload: offset });
};
